import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUndoCancelAthletePackage(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const undoCancelAthletePackage = (athletePackageId: string): Promise<AxiosResponse<null>> => {
    return client.post(`athlete-packages/${athletePackageId}/undo-cancel/`, {});
  };

  return useMutation(undoCancelAthletePackage, {
    onSuccess: () => {
      queryClient.invalidateQueries('athletePackages');
    },
  });
}
